// Theme: obsidian-bloom
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'obsidian-bloom',
  name: 'OBSIDIAN BLOOM',
  tagline: 'OBSIDIAN BLOOM',
  description: 'Violeta raro de flor de obsidiana em vulcao negro.',
  category: 'premium-status',
  tier: 'legendary',
  basePrice: 5250,
  swatches: ['#110B1E', '#1E1535', '#A855F7', '#F0E9FF'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '14px',
      '--shadow-card': '0 14px 34px rgba(0, 0, 0, 0.30)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 58%, transparent)'
    },
    shellClasses: 'font-sans theme-obsidian-bloom'
  },
  colorVars: {
    '--accent': '#A855F7',
    '--accent-foreground': '#110B1E',
    '--background': '#110B1E',
    '--border': '#4A2A8A',
    '--card': '#1E1535',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F0E9FF',
    '--card-glow': 'color-mix(in srgb, var(--primary) 12%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#110B1E',
    '--foreground': '#F0E9FF',
    '--hold-fill': '#A855F7',
    '--input': '#4A2A8A',
    '--modal-bg': '#110B1E',
    '--modal-border': '#4A2A8A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 14px 34px rgba(0, 0, 0, 0.30)',
    '--muted': '#4A2A8A',
    '--muted-foreground': '#F0E9FF',
    '--nav-active': '#A855F7',
    '--nav-bg': '#1E1535',
    '--popover': '#1E1535',
    '--popover-foreground': '#F0E9FF',
    '--primary': '#A855F7',
    '--primary-foreground': '#110B1E',
    '--ring': '#A855F7',
    '--secondary': '#4A2A8A',
    '--secondary-foreground': '#F0E9FF',
    '--streak': '#A855F7',
    '--success': '#22c55e',
    '--success-foreground': '#110B1E',
    '--xp': '#A855F7',
    '--xp-bg': '#1E1535'
  },
  resolvedVars: {
    '--accent': '#A855F7',
    '--accent-foreground': '#110B1E',
    '--accent-foreground-hsl': '259 46% 8%',
    '--accent-foreground-oklch': 'from #110B1E l c h',
    '--accent-hsl': '271 91% 65%',
    '--accent-oklch': 'from #A855F7 l c h',
    '--background': '#110B1E',
    '--background-hsl': '259 46% 8%',
    '--background-oklch': 'from #110B1E l c h',
    '--border': '#4A2A8A',
    '--border-hsl': '260 53% 35%',
    '--border-oklch': 'from #4A2A8A l c h',
    '--border-w': '1px',
    '--card': '#1E1535',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F0E9FF',
    '--card-foreground-hsl': '259 100% 96%',
    '--card-foreground-oklch': 'from #F0E9FF l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 12%, transparent)',
    '--card-hsl': '257 43% 15%',
    '--card-oklch': 'from #1E1535 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#110B1E',
    '--destructive-foreground-hsl': '259 46% 8%',
    '--destructive-foreground-oklch': 'from #110B1E l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F0E9FF',
    '--foreground-hsl': '259 100% 96%',
    '--foreground-oklch': 'from #F0E9FF l c h',
    '--hold-fill': '#A855F7',
    '--hold-fill-hsl': '271 91% 65%',
    '--hold-fill-oklch': 'from #A855F7 l c h',
    '--input': '#4A2A8A',
    '--input-hsl': '260 53% 35%',
    '--input-oklch': 'from #4A2A8A l c h',
    '--modal-bg': '#110B1E',
    '--modal-bg-hsl': '259 46% 8%',
    '--modal-bg-oklch': 'from #110B1E l c h',
    '--modal-border': '#4A2A8A',
    '--modal-border-hsl': '260 53% 35%',
    '--modal-border-oklch': 'from #4A2A8A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 14px 34px rgba(0, 0, 0, 0.30)',
    '--muted': '#4A2A8A',
    '--muted-foreground': '#F0E9FF',
    '--muted-foreground-hsl': '259 100% 96%',
    '--muted-foreground-oklch': 'from #F0E9FF l c h',
    '--muted-hsl': '260 53% 35%',
    '--muted-oklch': 'from #4A2A8A l c h',
    '--nav-active': '#A855F7',
    '--nav-active-hsl': '271 91% 65%',
    '--nav-active-oklch': 'from #A855F7 l c h',
    '--nav-bg': '#1E1535',
    '--nav-bg-hsl': '257 43% 15%',
    '--nav-bg-oklch': 'from #1E1535 l c h',
    '--popover': '#1E1535',
    '--popover-foreground': '#F0E9FF',
    '--popover-foreground-hsl': '259 100% 96%',
    '--popover-foreground-oklch': 'from #F0E9FF l c h',
    '--popover-hsl': '257 43% 15%',
    '--popover-oklch': 'from #1E1535 l c h',
    '--primary': '#A855F7',
    '--primary-foreground': '#110B1E',
    '--primary-foreground-hsl': '259 46% 8%',
    '--primary-foreground-oklch': 'from #110B1E l c h',
    '--primary-hsl': '271 91% 65%',
    '--primary-oklch': 'from #A855F7 l c h',
    '--radius': '14px',
    '--ring': '#A855F7',
    '--ring-hsl': '271 91% 65%',
    '--ring-oklch': 'from #A855F7 l c h',
    '--secondary': '#4A2A8A',
    '--secondary-foreground': '#F0E9FF',
    '--secondary-foreground-hsl': '259 100% 96%',
    '--secondary-foreground-oklch': 'from #F0E9FF l c h',
    '--secondary-hsl': '260 53% 35%',
    '--secondary-oklch': 'from #4A2A8A l c h',
    '--shadow-card': '0 14px 34px rgba(0, 0, 0, 0.30)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 58%, transparent)',
    '--streak': '#A855F7',
    '--streak-hsl': '271 91% 65%',
    '--streak-oklch': 'from #A855F7 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#110B1E',
    '--success-foreground-hsl': '259 46% 8%',
    '--success-foreground-oklch': 'from #110B1E l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(271 91% 65% / 0.15)',
    '--xp': '#A855F7',
    '--xp-bg': '#1E1535',
    '--xp-bg-hsl': '257 43% 15%',
    '--xp-bg-oklch': 'from #1E1535 l c h',
    '--xp-hsl': '271 91% 65%',
    '--xp-oklch': 'from #A855F7 l c h'
  }
}
